import { of } from "rxjs";
import { actionQuestInfoUpdate } from "../../info/quest/actionQuestInfo";
export var networkNoticeQuestUpdateHandler = function (action$, state$, deps) { return function (res) {
    var quests = state$.value.questInfo.quest;
    var questsMap = new Map();
    if (quests != undefined) {
        quests.forEach(function (val) {
            questsMap.set(val.questId, val);
        });
    }
    if (res.quest !== undefined) {
        res.quest.forEach(function (value) {
            if (questsMap.has(value.questId)) {
                questsMap.set(value.questId, value);
            }
        });
        res.quest = Array.from(questsMap.values());
    }
    return of(actionQuestInfoUpdate(res));
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/network/handlers/networkNoticeQuestUpdateHandler.ts
// module id = 2016
// module chunks = 3